export const maps = {
  "Rain-1": "wi-day-rain",
  "Rain-2": "wi-night-alt-rain",
  "Clear-1": "wi-day-sunny",
  "Clear-2": "wi-night-clear",
  "Snow-1": "wi-day-snow",
  "Snow-2": "wi-night-alt-snow",
  Wind: "wi-cloudy-windy",
  "Clouds-2": "wi-night-alt-cloudy",
  "Clouds-1": "wi-day-cloudy",
};
